import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PodsDropdownComponent } from "./components/pods-dropdown/pods-dropdown.component";
import { PrimeNgModule } from "./modules/prime-ng/prime-ng.module";
import { FormsModule } from "@angular/forms";
import { PaginatorComponent } from "./components/paginator/paginator.component";
import { DynamicCardsComponent } from "./components/dynamic-cards/dynamic-cards.component";
import { FilterDropdownComponent } from "./components/filter-dropdown/filter-dropdown.component";
import { WidgetComponent } from "./components/widget/widget.component";
import { HighchartComponent } from "./components/highchart/highchart.component";
import { HighchartsChartModule } from "highcharts-angular";
import { SkeletonModule } from "primeng/skeleton";
import { DynamicSkeletonLoaderComponent } from "../components/dynamic-skeleton-loader/dynamic-skeleton-loader.component";
import { GenericListingComponent } from "./components/generic-listing/generic-listing.component";
import { HorizontalBarComponent } from "./components/horizontal-bar/horizontal-bar.component";
import { CircularDownloadProgressComponent } from "./components/circular-download-progress/circular-download-progress.component";
import { DynamicTableComponent } from "./components/dynamic-table/dynamic-table.component";
import { SocialIconComponent } from "@shared/components/social-icon/social-icon.component";
import { GridLoaderLineComponent } from "@shared/components/grid-loader-line/grid-loader-line.component";
import { OverlayPanelTooltipDirective } from "./directives/overlay-panel-tooltip.directive";
import { MonthlyCalendarComponent } from "./components/monthly-calendar/monthly-calendar.component";
import { VotingColumnComponent } from "./voting-column/voting-column.component";
import { SummaryColumnComponent } from "./summary-column/summary-column.component";
import { MenuNativePrimeNgV2Component } from "@shared/components/menu-native-primeng-v2/menu-native-primeng-v2.component";
import { CompanyHeatMapComponent } from "./components/company-heat-map/company-heat-map.component";
import { HeatmapGridComponent } from "../components/heatmap-grid/heatmap-grid.component";
import { CompanyDetailsUrlPipe } from "./pipes/company-details-url.pipe";
import { InteractionScatterChartComponent } from "./components/interaction-scatter-chart/interaction-scatter-chart.component";
import { PieChartComponent } from "../components/pie-chart/pie-chart.component";
import { InteractionHistoryComponent } from "./components/interaction-history/interaction-history.component";
import { InteractionDetailsComponent } from "./components/interaction-details/interaction-details.component";
import { InteractionIconPipe } from "./pipes/interaction-icon.pipe";
import { AdminPanelComponent } from "../components/adminpanel/admin-panel.component";
import { LastExecutionColumnComponent } from "./components/last-execution-column/last-execution-column.component";
import { GroupsColumnComponent } from "./components/groups-column/groups-column.component";
import { HighlightPipe } from "./pipes/highlight.pipe";
import { NgSelectModule } from "@ng-select/ng-select";
import { DcCompanyDropdownComponent } from "./components/dc-company-dropdown/dc-company-dropdown";
import { InteractionsChartComponent } from "./components/interactions-chart/interactions-chart.component";
import { SpreadsheetDownloadComponent } from "./components/spreadsheet-download/spreadsheet-download.component";

@NgModule({
  declarations: [
    PodsDropdownComponent,
    PaginatorComponent,
    DynamicCardsComponent,
    FilterDropdownComponent,
    WidgetComponent,
    HighchartComponent,
    DynamicSkeletonLoaderComponent,
    GenericListingComponent,
    HorizontalBarComponent,
    CircularDownloadProgressComponent,
    DynamicTableComponent,
    SocialIconComponent,
    GridLoaderLineComponent,
    OverlayPanelTooltipDirective,
    MonthlyCalendarComponent,
    CompanyHeatMapComponent,
    HeatmapGridComponent,
    CompanyDetailsUrlPipe,
    InteractionScatterChartComponent,
    PieChartComponent,
    InteractionHistoryComponent,
    InteractionDetailsComponent,
    InteractionIconPipe,
    VotingColumnComponent,
    SummaryColumnComponent,
    MenuNativePrimeNgV2Component,
    AdminPanelComponent,
    LastExecutionColumnComponent,
    GroupsColumnComponent,
    HighlightPipe,
    DcCompanyDropdownComponent,
    InteractionsChartComponent,
    SpreadsheetDownloadComponent
  ],
  exports: [
    PodsDropdownComponent,
    PaginatorComponent,
    DynamicCardsComponent,
    FilterDropdownComponent,
    WidgetComponent,
    HighchartComponent,
    DynamicSkeletonLoaderComponent,
    GenericListingComponent,
    HorizontalBarComponent,
    CircularDownloadProgressComponent,
    DynamicTableComponent,
    SocialIconComponent,
    GridLoaderLineComponent,
    OverlayPanelTooltipDirective,
    MonthlyCalendarComponent,
    CompanyHeatMapComponent,
    HeatmapGridComponent,
    CompanyDetailsUrlPipe,
    InteractionScatterChartComponent,
    PieChartComponent,
    InteractionHistoryComponent,
    InteractionDetailsComponent,
    InteractionIconPipe,
    HighlightPipe,
    SpreadsheetDownloadComponent
  ],
  imports: [CommonModule, FormsModule, PrimeNgModule, HighchartsChartModule, SkeletonModule, NgSelectModule],
})
export class CoreModule {}
